import React, { FC } from 'react';
import styled from 'styled-components';

export const SLoginLayout = styled.div`
  display: flex;
  height: auto;
  min-height: 100vh;

  > div {
    display: flex;
    flex: 1;
    justify-content: center;
  }
`;

interface IImageProps {
  imagePath: string;
}

export const SImage = styled.div<IImageProps>`
  display: none;
  flex: 0;

  background-image: url(${({ imagePath }) => imagePath});
  background-size: cover;
  background-position: center;

  @media (min-width: 1200px) {
    display: flex;
    flex: 1;
  }
`;

interface ILoginLayoutProps {
  children: React.ReactNode;
}

const LoginLayout: FC<ILoginLayoutProps> = ({ children }) => {
  return (
    <SLoginLayout>
      <div>{children}</div>
      <SImage imagePath={process.env.PUBLIC_URL + '/assets/images/authIllustration.svg'} />
    </SLoginLayout>
  );
};

export default LoginLayout;
